/**
 * Special cards ship full-body art (649×900) instead of a square headshot.
 * Version 72 has the flag but its art is still drawn as a headshot.
 */
export const usesFullPlayerImage = (hasDynamicImage, versionId) => !!hasDynamicImage && versionId !== 72;
/*
  Where the full-body art sits in a square crop, as fractions of the square:
  scaled up and shifted so the head and shoulders fill it like a headshot.
*/
export const FULL_IMAGE_IN_SQUARE = {
    width: 1.4,
    left: -0.2,
    top: -0.28,
    aspectRatio: 649 / 900,
};
//# sourceMappingURL=playerImage.js.map